import React from 'react';
import { FaRedo, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft } from 'react-icons/fa';

interface ButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  iconPosition?: 'left' | 'right';
  reverseIcon?: boolean; // アイコンを反転させるプロパティを追加
  iconType?: 'left' | 'right' | 'redo' | 'doubleLeft'; // アイコンの種類を指定
  iconSize?: number; // アイコンのサイズを指定するプロパティを追加
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  className,
  disabled,
  style,
  iconPosition = 'right',
  reverseIcon = false, // デフォルトは反転しない
  iconType,
  iconSize = 24, // デフォルトのアイコンサイズを24pxに設定
}) => {
  // アイコンの選択
  const renderIcon = () => {
    const iconStyle = { fontSize: `${iconSize}px` }; // アイコンのサイズを指定

    switch (iconType) {
      case 'left':
        return <FaAngleLeft style={iconStyle} />;
      case 'right':
        return <FaAngleRight style={iconStyle} />;
      case 'redo':
        return <FaRedo style={iconStyle} />;
      case 'doubleLeft':
        return <FaAngleDoubleLeft style={iconStyle} />;
      default:
        return null;
    }
  };

  return (
    <button
      onClick={onClick}
      className={`btn ${className}`}
      disabled={disabled}
      style={style}
    >
      {iconPosition === 'left' && (
        <span
          className="btn-icon"
          style={{
            transform: reverseIcon ? 'scaleX(-1)' : 'none', // reverseIconがtrueの場合、アイコンを反転
          }}
        >
          {renderIcon()}
        </span>
      )}
      <span className="btn-content">{children}</span>
      {iconPosition === 'right' && (
        <span
          className="btn-icon"
          style={{
            transform: reverseIcon ? 'scaleX(-1)' : 'none', // reverseIconがtrueの場合、アイコンを反転
          }}
        >
          {renderIcon()}
        </span>
      )}
    </button>
  );
};

export default Button;
